angular.
module("dx.webapp.api").
factory("dxApi", function apiService(
	dxApiLegacyFinalGrades,
	dxApiLegacyGrades,
	dxApiLegacyMasterTools,
	dxApiV1Exams,
	dxApiV1ExamTemplates,
	dxApiV1Gradings,
	dxApiV1Groups,
	dxApiV1Rubrics,
	dxApiV1TeacherData,
	dxApiV1Users,
	dxApiV1Nodes,
	dxApiV1SAML,
	dxApiV1Jobs,
	dxApiV1Mastertools,
	dxApiV1ClientVersions,
	dxApiV1Invites,
	dxApiV1OnlineResources,
	dxApiV1Skolon,
	dxApiV1StudentInfo,
	dxApiV1GradingMatrix,
	dxApiV1Files,
	dxApiV1GradesSpreadsheet,
	dxApiV1Students,
	dxApiV1ExternalTools,
	dxApiV1LoginCode
) {
	"use strict";

	return {
		v1: {
			exams: dxApiV1Exams,
			examTemplates: dxApiV1ExamTemplates,
			gradings: dxApiV1Gradings,
			groups: dxApiV1Groups,
			rubrics: dxApiV1Rubrics,
			teacherData: dxApiV1TeacherData,
			users: dxApiV1Users,
			nodes: dxApiV1Nodes,
			saml: dxApiV1SAML,
			jobs: dxApiV1Jobs,
			mastertools: dxApiV1Mastertools,
			clientversions: dxApiV1ClientVersions,
			invites: dxApiV1Invites,
			onlineResources: dxApiV1OnlineResources,
			skolon: dxApiV1Skolon,
			studentinfo: dxApiV1StudentInfo,
			gradingMatrix: dxApiV1GradingMatrix,
			files: dxApiV1Files,
			gradesSpreadsheet: dxApiV1GradesSpreadsheet,
			students: dxApiV1Students,
			externalTools: dxApiV1ExternalTools,
			loginCode: dxApiV1LoginCode,
		},
		legacy: {
			grades: dxApiLegacyGrades,
			finalGrades: dxApiLegacyFinalGrades,
			masterTools: dxApiLegacyMasterTools,
		},
	};
});
